import { render } from "./ConnectBank.vue?vue&type=template&id=f171a6ea"
import script from "./ConnectBank.vue?vue&type=script&lang=js"
export * from "./ConnectBank.vue?vue&type=script&lang=js"

import exportComponent from "/usr/src/app/vue-goparity/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__